export interface DemoFilters {
  searchText: string;
  product: string[];
  industry: string[];
  discipline: string[];
  material: string[];
}

export function defaultDemoFilters(): DemoFilters {
  return { searchText: '', product: [], industry: [], discipline: [], material: [] };
}
